import React, { Component } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import "./Home.css";

class HomeSlider extends Component {
  render() {
    const settings = {
      dots: true,
      infinite: true,
      speed: 600,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      arrows: false,
    };

    return (
      <Slider {...settings}>
        <div className="slider-item">
          <img
            src="/Asset/hero_4.jpg"
            alt="slide"
            className="slider-img"
          />

          <div className="slider-overlay">
            {/* <img src="/logo.png" alt="FlavoursNest Graphic" className="Hlogo-img" /> */}
            <h1 className="logo-text">Welcome to <span className="text-dark-brown ms-2">Flavours</span><span className="text-golden-tan">Nest</span> </h1>
            <p className="tagline">Discover Your Next Favorite Recipe...!</p>
            <div className="slider-buttons">
              <Link to="/view-recipes" className="btn-main">
                Explore Recipes
              </Link>
            </div>

          </div>
        </div>

        <div className="slider-item">
          <img
            src="/Asset/hero_3.png"
            alt="slide"
            className="slider-img"
          />
          <div className="slider-overlay">
            <h1 className="logo-text">What’s in Your <span className="text-dark-brown ms-2"> Kitchen</span>?</h1>
            <p className="tagline">Add your ingredients and discover recipes you can cook right now.</p>
            <div className="slider-buttons">

              <a href="#search" className="btn-main">
                Search by Ingredients
              </a>
            </div>

          </div>
        </div>
      </Slider>
    );
  }
}

export default HomeSlider;